import {
  cancelAppointment,
  myAppointment,
  reserveAppointment,
  searchAppointment,
} from "@/services/appointment.service";

export default {
  namespaced: true,
  state: {
    // STATUS
    appointment: {},
    appointmentStatus: "init",
    calendar: null,
  },
  getters: {
    getAppointment(state) {
      return state.appointment;
    },
    // STATUS
    getAppointmentStatus(state) {
      return state.appointmentStatus;
    },
    getCalendar(state) {
      return state.calendar;
    },
  },
  mutations: {
    // STATUS
    APPOINTMENT_STATUS(state, value) {
      state.appointmentStatus = value;
    },
    SET_APPOINTMENT(state, value) {
      state.appointment = value;
    },
    SET_CALENDAR(state, value) {
      state.calendar = value;
    },
  },
  actions: {
    async sendAppointment({ commit }, params) {
      commit("APPOINTMENT_STATUS", "pending");
      try {
        const { data } = await reserveAppointment(params);
        localStorage.setItem("Occupation", params.occupation);
        commit("APPOINTMENT_STATUS", "init");
        return data;
      } catch (error) {
        commit("APPOINTMENT_STATUS", "init");
        throw error;
      }
    },
    async getAppointment({ commit }, params) {
      commit("APPOINTMENT_STATUS", "pending");
      try {
        const { data } = await searchAppointment(params);
        commit("SET_CALENDAR", data.items);
        if (Object.keys(data.items).length <= 0) {
          commit("SET_APPOINTMENT", { noHour: true });
        } else {
          let tempNewObj = {};

          // const d = new Date();
          // let hour = d.getHours();
          // let today = d.getDay();

          for (let day in data.items) {
            let tempObjKey = day.split(" ")[0];

            // console.log("========================================");
            // let tempToday = moment().local().format();
            // let tempDay = moment(day).format();

            // console.log("d (Today)", tempToday)
            // console.log("moment(day)", tempDay)

            // console.log( "isSame", moment(tempDay).isSame(tempToday, 'days') )
            // console.log( "isAfter", moment(tempDay).isAfter(tempDay, 'hours') )
            // console.log( "isBefore", moment(tempDay).isBefore(tempDay, 'hours') )

            if (!(tempObjKey in tempNewObj))
              tempNewObj[tempObjKey] = { hours: [] };

            // if(!moment(tempDay).isSame(tempToday, 'days') ) {
            tempNewObj[tempObjKey]["hours"].push(day.split(" ")[1]);
            // }
          }

          console.log(tempNewObj);

          commit("SET_APPOINTMENT", {
            itens: data.item,
            formated: tempNewObj,
          });
          commit("APPOINTMENT_STATUS", "init");

          return {
            itens: data.items,
            formated: tempNewObj,
          };
        }
      } catch (error) {
        commit("APPOINTMENT_STATUS", "init");
        throw error;
      }
    },
    async listAppointment({ commit }, params) {
      commit("APPOINTMENT_STATUS", "pending");
      try {
        const { data } = await myAppointment(params);
        commit("APPOINTMENT_STATUS", "init");
        commit("SET_APPOINTMENT", data.items);
        return data;
      } catch (error) {
        commit("APPOINTMENT_STATUS", "init");
        throw error;
      }
    },
    async cancelAppointment({ commit }, params) {
      commit("APPOINTMENT_STATUS", "pending");
      try {
        const { data } = await cancelAppointment(params);
        commit("APPOINTMENT_STATUS", "init");
        return data;
      } catch (error) {
        commit("APPOINTMENT_STATUS", "init");
        throw error;
      }
    },
  },
};
